import { DefaultComponentProps } from '@ui-components/neo.tax';
import { Control, Controller, FieldValues, Path, UseControllerProps } from 'react-hook-form';

import { MonthYearPicker, MonthYearPickerProps } from './MonthYearPicker';

export interface ControlledMonthYearPickerProps<T extends FieldValues = FieldValues, K extends Path<T> = Path<T>>
  extends Omit<MonthYearPickerProps, 'error' | 'value'>, DefaultComponentProps {
  control: Control<T, K>;
  id: string;
  name: K;
  rules?: UseControllerProps<T, K>['rules'];
}

export const ControlledMonthYearPicker = <T extends FieldValues = FieldValues, K extends Path<T> = Path<T>>({
  control,
  errorText,
  name,
  rules,
  ...props
}: ControlledMonthYearPickerProps<T, K>): JSX.Element => (
  <Controller<T, K>
    control={control}
    name={name}
    rules={rules}
    render={({ field: { ref: _ref, ...rest }, fieldState: { error } }): React.ReactElement => {
      const errorMsg = errorText || error?.message;
      return <MonthYearPicker {...props} {...rest} error={!!errorMsg} errorText={errorMsg} />;
    }}
  />
);
